import { BooleanOrNullOrUndefined, NumberOrNullOrUndefined, StringOrNullOrUndefined } from "src/app/shared/utils";

export class ClientCaseNote {
  id?: number;
  patient_id: number = 0;
  date: string = '';
  observations: string = '';
  reference_number?: string;
  pinned?: boolean;
  created_at?: Date | string;
  updated_at?: Date | string;
  deleted_at?: Date | string | null;

  static build = (data: Partial<ClientCaseNote>): ClientCaseNote => ({
    id: data.id ? NumberOrNullOrUndefined(data.id) : undefined,
    patient_id: NumberOrNullOrUndefined(data.patient_id) ?? 0,
    date: StringOrNullOrUndefined(data.date) ?? '',
    observations: StringOrNullOrUndefined(data.observations) ?? '',
    reference_number: StringOrNullOrUndefined(data.reference_number),
    pinned: BooleanOrNullOrUndefined(data.pinned),
    created_at: data.created_at ? new Date(data.created_at) : undefined,
    updated_at: data.updated_at ? new Date(data.updated_at) : undefined,
    deleted_at: data.deleted_at ? new Date(data.deleted_at) : null,
  });
}

export interface CaseNotesListResponse {
  patient_id: number;
  case_notes: ClientCaseNote[];
}
